// import React, { useState, useEffect } from 'react';
// import {
//   Card,
//   Form,
//   InputNumber,
//   Switch,
//   Button,
//   Space,
//   Divider,
//   Typography,
//   message,
//   Spin,
//   Row,
//   Col,
//   Select,
//   TimePicker
// } from 'antd';
// import { SaveOutlined, ReloadOutlined, SettingOutlined } from '@ant-design/icons';
// import dayjs from 'dayjs';
// import { toast } from 'react-toastify';
// import { createSettingsApi, getSettingsApi } from '../../services/settingsApi';
// import { useParams } from 'react-router-dom';

// const { Title, Text } = Typography;
// const { Option } = Select;

// const GeneralSettingsPage = () => {
//   const [form] = Form.useForm();
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [settings, setSettings] = useState({
//     commission: {
//       percentage: 5,
//       enabled: true,
//       minimumAmount: 100
//     },
//     monthlycron: {
//       enabled: true,
//       runTime: dayjs('09:00', 'HH:mm'),
//       dayOfMonth: 1,
//       emailTemplate: 'default',
//       recipientType: 'all'
//     }
//   });

//   // Mock API functions - replace with actual API calls
// let {tenantId} = useParams()

//   const fetchSettings = async () => {
//     setLoading(true);
//     try {
//       // Simulate API call
//     //   await new Promise(resolve => setTimeout(resolve, 1000));
//     let res = await   getSettingsApi({tenantId})
//     console.log(res,"responsnsns")
//       // Mock response - replace with actual API call
//       const mockData = {
//         commission: {
//           percentage: 7.5,
//           enabled: true,
//           minimumAmount: 150
//         },
//         monthlycron: {
//           enabled: false,
//           runTime: dayjs('10:30', 'HH:mm'),
//           dayOfMonth: 15,
//           emailTemplate: 'newsletter',
//           recipientType: 'active'
//         }
//       };

//       setSettings(mockData);
//       form.setFieldsValue({
//         ...mockData,
//         monthlycron: {
//           ...mockData.monthlycron,
//           runTime: mockData.monthlycron.runTime
//         }
//       });

//       message.success('Settings loaded successfully');
//     } catch (error) {
//       message.error('Failed to load settings');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const saveSettings = async (values) => {
//     setSaving(true);
//     console.log(values,"valuesss")
//     try {
//       // Simulate API call
//     //   await new Promise(resolve => setTimeout(resolve, 1500));

//       // Format the data for your backend
//       const formattedData = {
//         commission: {
//           name: 'Commission Settings',
//           settingName: 'commission',
//           slug: 'commission',
//           value: {
//             percentage: values.commission.percentage,
//             enabled: values.commission.enabled,
//             // minimumAmount: values.commission.minimumAmount
//           }
//         },
//         monthlycron: {
//           name: 'Monthly Campaign Settings',
//           settingName: 'monthlycron',
//           slug: 'monthlycron',
//           value: {
//             enabled: values.monthlycron.enabled,
//             // runTime: values?.monthlycron?.runTime.format('HH:mm'),
//             dayOfMonth: values.monthlycron.dayOfMonth,
//             // emailTemplate: values.monthlycron.emailTemplate,
//             // recipientType: values.monthlycron.recipientType
//           }
//         }
//       };

//       console.log('Saving settings:', formattedData);
//       let res = await createSettingsApi(formattedData,tenantId)
//       console.log(res,"final respons e")
//       setSettings(values);
//       if(res?.sucess)
//       toast.success('Settings saved successfully');
//     } catch (error) {
//         console.log(error,"error ")
//       toast.error('Failed to save settings');
//     } finally {
//       setSaving(false);
//     }
//   };

//   const resetSettings = () => {
//     form.resetFields();
//     message.info('Settings reset to original values');
//   };

//   useEffect(() => {
//     fetchSettings();
//   }, []);

//   const onFinish = (values) => {
//     saveSettings(values);
//   };

//   if (loading) {
//     return (
//       <div style={{ textAlign: 'center', padding: '50px' }}>
//         <Spin size="large" />
//         <div style={{ marginTop: '16px' }}>
//           <Text>Loading settings...</Text>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
//       <div style={{ marginBottom: '24px' }}>
//         <Title level={2} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
//           <SettingOutlined />
//           General Settings
//         </Title>
//         <Text type="secondary">
//           Configure commission rates and marketing email campaign settings
//         </Text>
//       </div>

//       <Form
//         form={form}
//         layout="vertical"
//         onFinish={onFinish}
//         initialValues={settings}
//         autoComplete="off"
//       >
//         <Row gutter={[24, 24]}>
//           {/* Commission Settings */}
//           <Col xs={24} lg={12}>
//             <Card
//               title={
//                 <Space>
//                   <SettingOutlined />
//                   Commission Settings
//                 </Space>
//               }
//               style={{ height: '100%' }}
//             >
//               <Form.Item
//                 label="Commission Percentage"
//                 name={['commission', 'percentage']}
//                 rules={[
//                   { required: true, message: 'Please enter commission percentage' },
//                   { type: 'number', min: 0, max: 100, message: 'Percentage must be between 0 and 100' }
//                 ]}
//                 extra="Set the commission rate as a percentage (0-100%)"
//               >
//                 <InputNumber
//                   style={{ width: '100%' }}
//                   min={0}
//                   max={100}
//                   step={0.1}
//                   precision={2}
//                   formatter={value => `${value}%`}
//                   parser={value => value.replace('%', '')}
//                   placeholder="Enter percentage"
//                 />
//               </Form.Item>

//               <Form.Item
//                 name={['commission', 'enabled']}
//                 valuePropName="checked"
//               >
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <Switch />
//                   <Text>Enable Commission System</Text>
//                 </div>
//               </Form.Item>
//             </Card>
//           </Col>

//           {/* Marketing Email Campaign Settings */}
//           <Col xs={24} lg={12}>
//             <Card
//               title={
//                 <Space>
//                   <SettingOutlined />
//                   Monthly Marketing Campaign
//                 </Space>
//               }
//               style={{ height: '100%' }}
//             >
//               <Form.Item
//                 name={['monthlycron', 'enabled']}
//                 valuePropName="checked"
//                 style={{ marginBottom: '16px' }}
//               >
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <Switch />
//                   <Text>Enable Monthly Email Campaign</Text>
//                 </div>
//               </Form.Item>

//               <Form.Item
//                 noStyle
//                 shouldUpdate={(prevValues, currentValues) =>
//                   prevValues.monthlycron?.enabled !== currentValues.monthlycron?.enabled
//                 }
//               >
//                 {({ getFieldValue }) => {
//                   const isEnabled = getFieldValue(['monthlycron', 'enabled']);
//                   return (
//                     <div style={{ opacity: isEnabled ? 1 : 0.5, pointerEvents: isEnabled ? 'auto' : 'none' }}>
//                       <Form.Item
//                         label="Day of Month"
//                         name={['monthlycron', 'dayOfMonth']}
//                         rules={[
//                           { required: isEnabled, message: 'Please select day of month' },
//                           { type: 'number', min: 1, max: 31, message: 'Day must be between 1 and 31' }
//                         ]}
//                         extra="Day of the month to run the campaign"
//                       >
//                         <Select placeholder="Select day">
//                           {Array.from({ length: 31 }, (_, i) => (
//                             <Option key={i + 1} value={i + 1}>
//                               {i + 1}
//                             </Option>
//                           ))}
//                         </Select>
//                       </Form.Item>

//                       {/* <Form.Item
//                         label="Run Time"
//                         name={['monthlycron', 'runTime']}
//                         rules={[
//                           { required: isEnabled, message: 'Please select run time' }
//                         ]}
//                         extra="Time of day to send the campaign"
//                       >
//                         <TimePicker
//                           style={{ width: '100%' }}
//                           format="HH:mm"
//                           placeholder="Select time"
//                         />
//                       </Form.Item> */}

//                       {/* <Form.Item
//                         label="Email Template"
//                         name={['monthlycron', 'emailTemplate']}
//                         rules={[
//                           { required: isEnabled, message: 'Please select email template' }
//                         ]}
//                       >
//                         <Select placeholder="Select template">
//                           <Option value="default">Default Template</Option>
//                           <Option value="newsletter">Newsletter Template</Option>
//                           <Option value="promotional">Promotional Template</Option>
//                           <Option value="announcement">Announcement Template</Option>
//                         </Select>
//                       </Form.Item> */}

//                       {/* <Form.Item
//                         label="Recipient Type"
//                         name={['monthlycron', 'recipientType']}
//                         rules={[
//                           { required: isEnabled, message: 'Please select recipient type' }
//                         ]}
//                       >
//                         <Select placeholder="Select recipients">
//                           <Option value="all">All Users</Option>
//                           <Option value="active">Active Users Only</Option>
//                           <Option value="subscribed">Subscribed Users</Option>
//                           <Option value="premium">Premium Users</Option>
//                         </Select>
//                       </Form.Item> */}
//                     </div>
//                   );
//                 }}
//               </Form.Item>
//             </Card>
//           </Col>
//         </Row>

//         <Divider />

//         <div style={{ textAlign: 'center' }}>
//           <Space size="middle">
//             <Button
//               type="default"
//               icon={<ReloadOutlined />}
//               onClick={resetSettings}
//               disabled={saving}
//             >
//               Reset
//             </Button>
//             <Button
//               type="primary"
//               icon={<SaveOutlined />}
//               htmlType="submit"
//               loading={saving}
//               size="large"
//             >
//               Save Settings
//             </Button>
//           </Space>
//         </div>
//       </Form>
//     </div>
//   );
// };

// export default GeneralSettingsPage;

import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  InputNumber,
  Switch,
  Button,
  Space,
  Divider,
  Typography,
  message,
  Spin,
  Row,
  Col,
  Select,
} from "antd";
import {
  SaveOutlined,
  ReloadOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { createSettingsApi, getSettingsApi } from "../../services/settingsApi";
import { useParams } from "react-router-dom";

const { Title, Text } = Typography;
const { Option } = Select;

const GeneralSettingsPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const { tenantId } = useParams();

  const [settings, setSettings] = useState({
    commission: {
      percentage: 0,
      enabled: false,
      minimumAmount: 0,
    },
    monthlycron: {
      enabled: false,
      runTime: dayjs("09:00", "HH:mm"),
      dayOfMonth: 1,
      emailTemplate: "default",
      recipientType: "all",
    },
  });

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const res = await getSettingsApi({ tenantId });
      console.log(res, "API Response");

      // Default values
      const defaultSettings = {
        commission: {
          percentage: 0,
          enabled: false,
        },
        monthlycron: {
          enabled: false,

          dayOfMonth: 1,
        },
      };

      let formattedData = { ...defaultSettings };

      // Process API data if available
      if (
        res?.sucess &&
        res?.data?.data &&
        Array.isArray(res.data?.data) &&
        res.data?.data.length > 0
      ) {
        res.data?.data.forEach((setting) => {
          console.log(setting, "setting");
          if (setting.slug === "commission" && setting.value) {
            formattedData.commission = {
              percentage: setting.value.percentage || 0,
              enabled: setting.value.enabled || false,
            };
          } else if (setting.slug === "monthlycron" && setting.value) {
            formattedData.monthlycron = {
              enabled: setting.value.enabled || false,
              dayOfMonth: setting.value.dayOfMonth || 1,
            };
          }
        });
      }

      setSettings(formattedData);
      form.setFieldsValue(formattedData);
      toast.success("Settings loaded successfully");
    } catch (error) {
      console.error("Error loading settings:", error);

      // Set defaults on error
      const errorDefaults = {
        commission: {
          percentage: 0,
          enabled: false,
          minimumAmount: 0,
        },
        monthlycron: {
          enabled: false,
          runTime: dayjs("09:00", "HH:mm"),
          dayOfMonth: 1,
          emailTemplate: "default",
          recipientType: "all",
        },
      };

      setSettings(errorDefaults);
      form.setFieldsValue(errorDefaults);
      message.error("Failed to load settings");
    } finally {
      setLoading(false);
    }
  };

  const saveSettings = async (values) => {
    setSaving(true);
    try {
      const formattedData = {
        commission: {
          name: "Commission Settings",
          settingName: "commission",
          slug: "commission",
          value: {
            percentage: values.commission.percentage,
            enabled: values.commission.enabled,
          },
        },
        monthlycron: {
          name: "Monthly Campaign Settings",
          settingName: "monthlycron",
          slug: "monthlycron",
          value: {
            enabled: values.monthlycron.enabled,
            dayOfMonth: values.monthlycron.dayOfMonth,
          },
        },
      };
      console.log(values, "valuess");

      const res = await createSettingsApi(formattedData, tenantId);

      if (res?.sucess) {
        setSettings(values);
        toast.success("Settings saved successfully");
      } else {
        throw new Error(res?.message || "Failed to save settings");
      }
    } catch (error) {
      console.error("Save error:", error);
      toast.error(error?.message || "Failed to save settings");
    } finally {
      setSaving(false);
    }
  };

  const resetSettings = () => {
    form.resetFields();
    message.info("Settings reset to original values");
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const onFinish = (values) => {
    saveSettings(values);
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <Spin size="large" />
        <div style={{ marginTop: "16px" }}>
          <Text>Loading settings...</Text>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: "24px", maxWidth: "1200px", margin: "0 auto" }}>
      <div style={{ marginBottom: "24px" }}>
        <Title
          level={2}
          style={{
            margin: 0,
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <SettingOutlined />
          General Settings
        </Title>
        <Text type="secondary">
          Configure commission rates and marketing email campaign settings
        </Text>
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={settings}
      >
        <Row gutter={[24, 24]}>
          {/* Commission Settings */}
          <Col xs={24} lg={12}>
            <Card
              title={
                <Space>
                  <SettingOutlined />
                  Commission Settings
                </Space>
              }
              style={{ height: "100%" }}
            >
              <Form.Item
                label="Commission Percentage"
                name={["commission", "percentage"]}
                rules={[
                  {
                    required: true,
                    message: "Please enter commission percentage",
                  },
                  {
                    type: "number",
                    min: 0,
                    max: 100,
                    message: "Percentage must be between 0 and 100",
                  },
                ]}
                extra="Set the commission rate as a percentage (0-100%)"
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  max={100}
                  step={0.1}
                  precision={2}
                  formatter={(value) => `${value}%`}
                  parser={(value) => value.replace("%", "")}
                  placeholder="Enter percentage"
                />
              </Form.Item>

              <Form.Item
                name={["commission", "enabled"]}
                valuePropName="checked"
                label="Enable Commission System"
              >
                <Switch />
              </Form.Item>
            </Card>
          </Col>

          {/* Marketing Email Campaign Settings */}
          {/* <Col xs={24} lg={12}>
            <Card
              title={
                <Space>
                  <SettingOutlined />
                  Monthly Marketing Campaign
                </Space>
              }
              style={{ height: '100%' }}
            >
             <Form.Item 
                name={['monthlycron', 'enabled']} 
                valuePropName="checked"
                label="Enable Monthly Email Campaign"
                >
                <Switch />
                </Form.Item>

              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) =>
                  prevValues.monthlycron?.enabled !== currentValues.monthlycron?.enabled
                }
              >
                {({ getFieldValue }) => {
                  const isEnabled = getFieldValue(['monthlycron', 'enabled']);
                  return (
                    <div style={{ opacity: isEnabled ? 1 : 0.5, pointerEvents: isEnabled ? 'auto' : 'none' }}>
                      <Form.Item
                        label="Day of Month"
                        name={['monthlycron', 'dayOfMonth']}
                        rules={[
                          { required: isEnabled, message: 'Please select day of month' },
                          { type: 'number', min: 1, max: 31, message: 'Day must be between 1 and 31' }
                        ]}
                        extra="Day of the month to run the campaign"
                      >
                        <Select placeholder="Select day">
                          {Array.from({ length: 31 }, (_, i) => (
                            <Option key={i + 1} value={i + 1}>
                              {i + 1}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  );
                }}
              </Form.Item>
            </Card>
          </Col> */}
        </Row>

        <Divider />

        <div style={{ textAlign: "center" }}>
          <Space size="middle">
            <Button
              type="default"
              icon={<ReloadOutlined />}
              onClick={resetSettings}
              disabled={saving}
            >
              Reset
            </Button>
            <Button
              type="primary"
              icon={<SaveOutlined />}
              htmlType="submit"
              loading={saving}
              size="large"
            >
              Save Settings
            </Button>
          </Space>
        </div>
      </Form>
    </div>
  );
};

export default GeneralSettingsPage;
